import React, { useEffect } from "react";
import { Drawer, Form, Input, InputNumber, Button, Select, Switch, Row, Col } from "antd";

const CreateMenu = ({ open, onClose, onSubmit, initialValues, cat }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [initialValues, open, form]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
    <Drawer
      title={initialValues ? "Edit Menu" : "Create Menu"}
      width={820}
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues ? initialValues : { is_active: true, is_veg: true }}
        onFinish={handleFinish}
      >
        <div className="page-card table-card">
          <div className="table-card-header">
            <div>
              <h3>{initialValues ? "Update Menu Details" : "Create Menu Details"}</h3>
              <p>Fill the details below to save the menu item.</p>
            </div>
          </div>

          <div className="form-grid-2">
            <Form.Item
              label="Menu Name"
              name="name"
              rules={[{ required: true, message: "Please enter menu name" }]}
            >
              <Input placeholder="Enter menu name" />
            </Form.Item>

            <Form.Item
              label="Menu Code"
              name="code"
            >
              <Input placeholder="Enter menu code" />
            </Form.Item>

            <Form.Item
              label="Category"
              name="category_id"
              rules={[{ required: true, message: "Please select category" }]}
            >
              <Select
                className="page-select"
                placeholder="Select category"
                options={(cat || []).map((item) => ({
                  label: item.name,
                  value: item.id,
                }))}
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>

            <Form.Item
              label="Price"
              name="price"
              rules={[{ required: true, message: "Please enter price" }]}
            >
              <InputNumber
                className="w-full"
                placeholder="Enter price"
                min={0}
              />
            </Form.Item>

            <Form.Item label="Tax (in %)" name="tax_pct">
              <InputNumber
                className="w-full"
                placeholder="Enter tax percentage"
                min={0}
              />
            </Form.Item>

            <Form.Item
              label="AC Price"
              name="ac_price"
              
            >
              <InputNumber
                className="w-full"
                placeholder="Enter AC price"
                min={0}
                disabled
              />
            </Form.Item>
          </div>

          <Row gutter={[16, 16]} style={{ marginTop: 4 }}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Veg / Non-Veg"
                name="is_veg"
                valuePropName="checked"
              >
                <Switch
                  className="custom-switch"
                  checkedChildren="Veg"
                  unCheckedChildren="Non-Veg"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Status"
                name="is_active"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren="Active"
                  unCheckedChildren="Inactive"
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="form-actions">
            <Button className="secondary-btn" onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="primary-btn">
              {initialValues ? "Update Menu" : "Save Menu"}
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};

export default CreateMenu;